export const Types = {
  RETRIEVE_SCHOOLS_BY_STATE_N_CITY_REQUEST: '[schools]RETRIEVE_SCHOOLS_BY_STATE_N_CITY_REQUEST',
  RETRIEVE_SCHOOLS_BY_STATE_N_CITY_SUCCESS: '[schools]RETRIEVE_SCHOOLS_BY_STATE_N_CITY_SUCCESS',
  RETRIEVE_SCHOOLS_BY_STATE_N_CITY_FAILURE: '[schools]RETRIEVE_SCHOOLS_BY_STATE_N_CITY_FAILURE',
};
